<template>
  <span class="svg-icon-reward-shopping-cart">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.0837 37.6674C28.6945 37.6674 30.0003 36.3616 30.0003 34.7508C30.0003 33.1399 28.6945 31.8341 27.0837 31.8341C25.4728 31.8341 24.167 33.1399 24.167 34.7508C24.167 36.3616 25.4728 37.6674 27.0837 37.6674Z" fill="#0078FF"/>
      <path d="M13.7497 37.6674C15.3605 37.6674 16.6663 36.3616 16.6663 34.7508C16.6663 33.1399 15.3605 31.8341 13.7497 31.8341C12.1388 31.8341 10.833 33.1399 10.833 34.7508C10.833 36.3616 12.1388 37.6674 13.7497 37.6674Z" fill="#0078FF"/>
      <path d="M8.06634 6.73419L7.73301 10.8175C7.66634 11.6009 8.28301 12.2509 9.06635 12.2509H34.583C35.283 12.2509 35.8663 11.7175 35.9163 11.0175C36.133 8.06751 33.883 5.66753 30.933 5.66753H10.483C10.3163 4.93419 9.983 4.23418 9.46633 3.65085C8.64966 2.76752 7.48302 2.25085 6.28302 2.25085H3.33301C2.64967 2.25085 2.08301 2.81752 2.08301 3.50085C2.08301 4.18419 2.64967 4.75085 3.33301 4.75085H6.23302C6.74968 4.75085 7.23301 4.96753 7.58301 5.3342C7.93301 5.71753 8.09967 6.21753 8.06634 6.73419Z" fill="#9ED9FF"/>
      <path d="M34.1837 14.7509H8.61709C7.91709 14.7509 7.35041 15.2842 7.28375 15.9675L6.68375 23.2175C6.45041 26.0509 8.68375 28.5009 11.5338 28.5009H30.0671C32.5671 28.5009 34.7671 26.4509 34.9504 23.9509L35.5004 16.1675C35.5671 15.4009 34.9671 14.7509 34.1837 14.7509Z" fill="#0078FF"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
